// Holidays created before the optional-holiday feature have holiday_type NULL, and the
// backend treats NULL as a standard holiday — so anything that is not OPTIONAL reads Public.
// @since NEXT_VERSION
export const getHolidayTypeLabel = (holidayType) =>
  holidayType === "OPTIONAL" ? "Optional" : "Public";

export default getHolidayTypeLabel;
